import { Environment } from 'src/app/config/environments';
import { FEATURE_DATA_ANALYTICS } from 'src/app/featureToggle/constants';
import { pageRolloutStrategy } from 'src/app/featureToggle/strategies/pageRolloutStrategy';

import { type FeatureConfig, PageId } from '../types';

export const dataAnalyticsFeature: FeatureConfig = {
  name: FEATURE_DATA_ANALYTICS,
  value: {
    [Environment.DEV]: {
      pages: {
        [PageId.CLASSIFY]: true,
        [PageId.SELECT_AD_TYPE]: true,
        [PageId.WRITE]: true,
        [PageId.MANAGE]: true,
        [PageId.MULTI_LOCATION]: true,
        [PageId.PAY_AND_POST]: true,
        [PageId.SUCCESS]: true,
        [PageId.CONCIERGE]: true,
        [PageId.GUARANTEED_HIRE]: true,
        [PageId.PREMIUM_PLUS]: true,
        [PageId.EDIT]: true,
        [PageId.EDIT_PAY_AND_POST]: true,
        [PageId.EDIT_SUCCESS]: true,
        [PageId.REFRESH]: true,
        [PageId.REFRESH_SUCCESS]: true,
        [PageId.REFRESH_ERROR]: true,
        [PageId.TEST_PAGE]: false,
      },
    },
    [Environment.STAGING]: {
      pages: {
        [PageId.CLASSIFY]: true,
        [PageId.SELECT_AD_TYPE]: true,
        [PageId.MULTI_LOCATION]: true,
        [PageId.WRITE]: true,
        [PageId.MANAGE]: true,
        [PageId.PAY_AND_POST]: true,
        [PageId.SUCCESS]: true,
        [PageId.CONCIERGE]: true,
        [PageId.GUARANTEED_HIRE]: true,
        [PageId.PREMIUM_PLUS]: true,
        [PageId.EDIT]: true,
        [PageId.EDIT_PAY_AND_POST]: true,
        [PageId.EDIT_SUCCESS]: true,
        [PageId.REFRESH]: true,
        [PageId.REFRESH_SUCCESS]: true,
        [PageId.REFRESH_ERROR]: true,
        [PageId.TEST_PAGE]: false,
      },
    },
    [Environment.PROD]: {
      pages: {
        [PageId.CLASSIFY]: true,
        [PageId.SELECT_AD_TYPE]: true,
        [PageId.WRITE]: true,
        [PageId.MANAGE]: true,
        [PageId.MULTI_LOCATION]: true,
        [PageId.PAY_AND_POST]: true,
        [PageId.SUCCESS]: true,
        [PageId.CONCIERGE]: true,
        [PageId.GUARANTEED_HIRE]: true,
        [PageId.PREMIUM_PLUS]: true,
        [PageId.EDIT]: true,
        [PageId.EDIT_PAY_AND_POST]: true,
        [PageId.EDIT_SUCCESS]: true,
        [PageId.REFRESH]: true,
        [PageId.REFRESH_SUCCESS]: true,
        [PageId.REFRESH_ERROR]: true,
        [PageId.TEST_PAGE]: true,
      },
    },
  },
  toFeature({ currentPage, env }) {
    return {
      name: this.name,
      enabled: pageRolloutStrategy(currentPage as PageId, this.value![env]),
    };
  },
};
